import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Grid,
  Chip,
  Box,
  OutlinedInput,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProjectData,
  fetchSubTaskData,
  fetchActiveMemberData,
  createTask,
  fetchAllTask,
} from "../../Redux/Slice/TaskMasterSlice";
import { useNavigate } from "react-router-dom";
import DynamicTable from "../../Components/Table/DynamicTable";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader/Loader";

const TaskMaster = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { SubTaskData, TaskProjectData, ActiveMemberData, FindAllTask } =
    useSelector((state) => state.TaskMaster);

  useEffect(() => {
    dispatch(fetchProjectData());
    dispatch(fetchSubTaskData());
    dispatch(fetchActiveMemberData());
    dispatch(fetchAllTask());
  }, [dispatch]);

  const [formData, setFormData] = useState({
    Description: "",
    DurationeType: null,
    TastName: "",
    Duration: "",
    Project: "",
    SubTask: [],
    TeamId: [],
    Type: null,
    Week: "",
    Day: "",
    Date: "",
  });

  const [formErrors, setFormErrors] = useState({});

  const durationOptions = [
    { id: 1, label: "Day" },
    { id: 2, label: "Hours" },
  ];

  const TaskTypeOptions = [
    { id: "One Time", label: "One Time" },
    { id: "Daily", label: "Daily" },
    { id: "Weekly", label: "Weekly" },
    { id: "Monthly", label: "Monthly" },
    { id: "Quarterly", label: "Quarterly" },
    { id: "Semiannualy", label: "Semiannualy" },
    { id: "Yearly", label: "Yearly" },
  ];

  const Member =
    (ActiveMemberData?.data?.map((el) => ({
      Name_id: el._id,
      Name_name: el.Name,
    })) || []).sort((a, b) => (a.Name_name || "").localeCompare(b.Name_name || ""));

  const Project =
    (TaskProjectData?.data?.map((item) => ({
      id: item._id,
      label: item.project_name,
    })) || []).sort((a, b) => (a.label || "").localeCompare(b.label || ""));

  const TASKS =
    SubTaskData?.data?.map((el) => ({
      SubTaskId: el._id,
      SubTaskName: el.SubTaskName,
    })) || [];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleAutocompleteChange =
    (name, isMultiSelect = false) =>
      (event, newValue) => {
        let valueToStore;
        if (isMultiSelect) {
          valueToStore = newValue
            ? newValue.map((item) => item.Name_id || item.id || item.SubTaskId)
            : [];
        } else if (name === "Project") {
          valueToStore = newValue ? newValue.id : "";
        } else {
          valueToStore = newValue;
        }

        setFormData((prev) => ({ ...prev, [name]: valueToStore }));
        setFormErrors((prev) => ({ ...prev, [name]: "" }));
      };

  const validateForm = () => {
    let errors = {};
    let isValid = true;

    if (!formData.TastName.trim()) {
      errors.TastName = "Task Name is required";
      isValid = false;
    }
    if (!formData.Duration) {
      errors.Duration = "Duration is required";
      isValid = false;
    }
    if (!formData.DurationeType) {
      errors.DurationeType = "Duration Type is required";
      isValid = false;
    }
    if (!formData.Project) {
      errors.Project = "Project is required";
      isValid = false;
    }
    if (formData.TeamId.length === 0) {
      errors.TeamId = "Member Name is required";
      isValid = false;
    }
    if (!formData.Type) {
      errors.Type = "Task Type is required";
      isValid = false;
    }
    if (formData.Type?.id === "Weekly" && !formData.Week) {
      errors.Week = "Week selection is required";
      isValid = false;
    }
    if (
      ["Monthly", "Quarterly", "Semiannualy", "Yearly"].includes(
        formData.Type?.id
      )
    ) {
      if (!formData.Date) {
        errors.Date = "Month selection is required";
        isValid = false;
      }
      if (!formData.Day || formData.Day < 1 || formData.Day > 31) {
        errors.Day = "Day must be between 1 and 31";
        isValid = false;
      }
    }
    if (!formData.Description.trim()) {
      errors.Description = "Description is required";
      isValid = false;
    }

    setFormErrors(errors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const taskData = {
      Description: formData.Description,
      DurationeType: formData.DurationeType?.label,
      TastName: formData.TastName,
      Duration: formData.Duration,
      Project: formData.Project,
      SubTask: formData.SubTask,
      TeamId: formData.TeamId,
      Type: formData.Type?.id,
      Week: formData.Type?.id === "Weekly" ? formData.Week : undefined,
      Day: ["Monthly", "Quarterly", "Semiannualy", "Yearly"].includes(
        formData.Type?.id
      )
        ? formData.Day
        : undefined,
      Date: ["Monthly", "Quarterly", "Semiannualy", "Yearly"].includes(
        formData.Type?.id
      )
        ? formData.Date
        : undefined,
    };

    try {
      await dispatch(createTask(taskData)).unwrap();
      toast.success("Task created successfully!");
      setFormData({
        Description: "",
        DurationeType: null,
        TastName: "",
        Duration: "",
        Project: "",
        SubTask: [],
        TeamId: [],
        Type: null,
        Week: "",
        Day: "",
        Date: "",
      });
      setFormErrors({});
      dispatch(fetchAllTask());
    } catch (error) {
      toast.error(`Error creating task: ${error.message || "Unknown error"}`);
    }
  };

  const handleViewDetails = (id) => {
    navigate(`/taskmaster/${id}`);
  };

  const rows = FindAllTask?.data?.map((el, index) => ({
    id: index + 1,
    MainId: el._id,
    TaskName: el.TastName,
    Duration: ` ${el.Duration}-${el.DurationeType}`,
    ProjectName: el?.Project?.project_name,
    TeamId: el.TeamId?.map((member) => member.Name).join(", "),
    Description: el.Description,
    SubTask: el.SubTask?.join(", "),
  }));

  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "TaskName", headerName: "Task Name", width: 200 },
    { field: "Duration", headerName: "Duration", width: 120 },
    // { field: "durationType", headerName: "Duration Type", width: 150 },
    { field: "ProjectName", headerName: "Project Name", width: 200 },
    { field: "TeamId", headerName: "Member Name", width: 180 },
    {
      field: "action",
      headerName: "Action",
      width: 150,
      sortable: false,
      renderCell: ({ row }) => (
        <button
          className="bg-[#122A47] text-white py-2 px-2 md:px-4 rounded hover:bg-[#0c2545]"
          onClick={() => handleViewDetails(row.MainId)}
        >
          View Details
        </button>
      ),
    },
  ];

  if (
    !TaskProjectData?.data ||
    !SubTaskData?.data ||
    !ActiveMemberData?.data ||
    !FindAllTask?.data
  ) {
    return <Loader />;
  }

  return (
    <div className="">
      <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
        Task Master
      </h3>

      <div className="Form_bg_color bg-white shadow-md rounded-xl mt-6">
        <h3 className="p-4 text-2xl font-semibold">Assign Task Form</h3>

        <form onSubmit={handleSubmit} className="grid grid-cols-12 gap-4 p-4">
          {/* Task Name */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <label className="font-semibold block mb-1">Task Name</label>
            <input
              type="text"
              name="TastName"
              placeholder="Enter Task Name"
              value={formData.TastName}
              onChange={handleInputChange}
              className={`bg-[#F3F8FB] w-full p-2 border-2 border-black rounded ${formErrors.TastName ? "border-red-500" : ""
                }`}
            />
            {formErrors.TastName && (
              <p className="text-red-500 text-xs mt-1">{formErrors.TastName}</p>
            )}
          </div>

          {/* Duration */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <label className="font-semibold block mb-1">Duration</label>
            <input
              type="number"
              name="Duration"
              placeholder="Enter Duration"
              value={formData.Duration}
              onChange={handleInputChange}
              className={`bg-[#F3F8FB] w-full p-2 border-2 border-black rounded ${formErrors.Duration ? "border-red-500" : ""
                }`}
            />
            {formErrors.Duration && (
              <p className="text-red-500 text-xs mt-1">{formErrors.Duration}</p>
            )}
          </div>

          {/* Duration Type Autocomplete (stores object) */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <label className="font-semibold block mb-1">Duration Type</label>
            <Autocomplete
              options={durationOptions}
              getOptionLabel={(option) => option.label || ""}
              value={formData.DurationeType}
              onChange={handleAutocompleteChange("DurationeType")} // Stores object
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Duration Type"
                  size="small"
                  className="custom-input"
                  error={!!formErrors.DurationeType}
                  helperText={formErrors.DurationeType}
                  InputProps={{
                    ...params.InputProps,
                    className: "w-full p-2 border-2 rounded",
                  }}
                />
              )}
            />
          </div>

          {/* Project Name Autocomplete (stores single ID string) */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <label className="font-semibold block mb-1">Project Name</label>
            <Autocomplete
              options={Project}
              getOptionLabel={(option) => option.label || ""}
              value={Project.find((p) => p.id === formData.Project) || null} // Find object for display
              onChange={handleAutocompleteChange("Project")} // Stores ID string
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Project Name"
                  size="small"
                  className="custom-input"
                  error={!!formErrors.Project}
                  helperText={formErrors.Project}
                  InputProps={{
                    ...params.InputProps,
                    className: "w-full p-2 border-2 rounded",
                  }}
                />
              )}
            />
          </div>

          {/* Select Task (Mui Select, multiple selection, sends array of ID strings) */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <label className="font-semibold block mb-1">Select Task</label>
            <FormControl fullWidth size="small">
              <InputLabel id="select-task-label">Select Task</InputLabel>
              <Select
                labelId="select-task-label"
                id="SubTask"
                name="SubTask"
                multiple // Important for sending an array
                value={formData.SubTask} // formData.SubTask will hold an array of ID strings
                onChange={handleInputChange} // This handles arrays for multiple selects
                input={
                  <OutlinedInput
                    label="Select Task"
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderWidth: "2px",
                        borderColor: "black",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "black",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "black",
                      },
                      backgroundColor: "#F3F8FB",
                      padding: "8px",
                    }}
                  />
                }
                className="w-full p-2  rounded bg-[#F3F8FB]"
                renderValue={(selectedIds) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selectedIds.map((id) => {
                      const task = TASKS.find((t) => t.SubTaskId === id);
                      return (
                        <Chip
                          key={id}
                          label={task ? task.SubTaskName : id}
                          size="small"
                        />
                      );
                    })}
                  </Box>
                )}
              >
                {TASKS.map((task) => (
                  <MenuItem key={task.SubTaskId} value={task.SubTaskId}>
                    {task.SubTaskName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          {/* Member Name Autocomplete (multiple selection, sends array of ID strings) */}
          <div className="col-span-12 lg:col-span-4 md:col-span-6">
            <label className="font-semibold block mb-1">Member Name</label>
            <Autocomplete
              options={Member}
              getOptionLabel={(option) => option.Name_name || ""}
              multiple // Important for sending an array
              value={Member.filter((m) => formData.TeamId.includes(m.Name_id))} // Filter objects for display
              onChange={handleAutocompleteChange("TeamId", true)} // Stores array of ID strings
              isOptionEqualToValue={(option, value) =>
                option.Name_id === value.Name_id
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Member"
                  size="small"
                  className="custom-input"
                  error={!!formErrors.TeamId}
                  helperText={formErrors.TeamId}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />
          </div>

          {/* Task Type (Frequency) Autocomplete (stores object) */}
          <div className="col-span-12 md:col-span-6 lg:col-span-4">
            <label className="font-semibold block mb-2">Task Type</label>
            <Autocomplete
              options={TaskTypeOptions}
              getOptionLabel={(option) => option.label || ""}
              value={formData.Type}
              onChange={handleAutocompleteChange("Type")} // Stores object
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Task Type"
                  variant="outlined"
                  size="small"
                  fullWidth
                  error={!!formErrors.Type}
                  helperText={formErrors.Type}
                  className="custom-input"
                />
              )}
            />
          </div>

          {/* Conditional Rendering for Week, Day, and Date */}
          {formData.Type?.id === "Weekly" && (
            <Grid item xs={12} sm={6}>
              <FormControl
                fullWidth
                sx={{ marginBottom: 3 }}
                error={!!formErrors.Week}
              >
                <InputLabel id="select-week-label">Select Week</InputLabel>
                <Select
                  labelId="select-week-label"
                  id="Week"
                  name="Week"
                  value={formData.Week}
                  onChange={handleInputChange}
                  label="Select Week"
                >
                  {[
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                    "Sunday",
                  ].map((day) => (
                    <MenuItem key={day} value={day}>
                      {day}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{formErrors.Week}</FormHelperText>
              </FormControl>
            </Grid>
          )}

          {["Monthly", "Quarterly", "Semiannualy", "Yearly"].includes(
            formData.Type?.id
          ) && (
              <>
                <Grid item xs={12} sm={6}>
                  <FormControl
                    fullWidth
                    sx={{ marginBottom: 3 }}
                    error={!!formErrors.Date}
                  >
                    <InputLabel id="select-month-label">Select Month</InputLabel>
                    <Select
                      labelId="select-month-label"
                      id="Date"
                      name="Date"
                      value={formData.Date}
                      onChange={handleInputChange}
                      label="Select Month"
                    >
                      {[...Array(12).keys()].map((month) => (
                        <MenuItem
                          key={month}
                          value={new Date(0, month).toLocaleString("default", {
                            month: "long",
                          })}
                        >
                          {new Date(0, month).toLocaleString("default", {
                            month: "long",
                          })}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>{formErrors.Date}</FormHelperText>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    id="Day"
                    name="Day"
                    label="Select Day"
                    type="number"
                    value={formData.Day}
                    onChange={handleInputChange}
                    error={!!formErrors.Day}
                    helperText={formErrors.Day}
                    InputProps={{ inputProps: { min: 1, max: 31 } }}
                    sx={{ marginBottom: 3 }}
                  />
                </Grid>
              </>
            )}

          {/* Description */}
          <div className="col-span-12">
            <label className="font-semibold block mb-1">Description</label>
            <textarea
              name="Description"
              value={formData.Description}
              onChange={handleInputChange}
              rows="4"
              className={`w-full p-2 border-2 border-black rounded ${formErrors.Description ? "border-red-500" : ""
                }`}
              placeholder="Enter Task Description"
            ></textarea>
            {formErrors.Description && (
              <p className="text-red-500 text-xs mt-1">
                {formErrors.Description}
              </p>
            )}
          </div>

          {/* Submit Button */}
          <div className="col-span-12 flex justify-center">
            <button
              type="submit"
              className="All_button text-white px-6 py-2 rounded transition"
            >
              Submit
            </button>
          </div>
        </form>
      </div>

      {/* You can paste your entire form and UI layout from your existing JSX code here (unchanged) */}
      {/* I omitted the repeated JSX to keep the response short. You already have that part. */}

      {/* Table Section */}
      <div className="mt-6 grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <DynamicTable columns={columns} rows={rows} />
        </div>
      </div>
    </div>
  );
};

export default TaskMaster;
